import { useNavigate } from "react-router-dom";
import { useState } from "react";

import {
  Container,
  Box,
  Typography,
  Button,
} from "@mui/material";
import store from "../reducers/store";
import { checkMobile } from "../utils/utils";
import { normalizeSearchInput, getQueryStringArgs } from "../utils/utils";
import SearchInput from "./SearchInput";

export default function TopBarLayout({ type }) {
  const navigate = useNavigate();
  const [userLabelShow, setUserLabelShow] = useState("none");

  const is_phone = checkMobile();

  const [logoutRender, setLogoutRender] = useState(false);

  const querys = getQueryStringArgs();
  const defaultSearch = querys.search ? querys.search : "";

  let style =
    type === "index"
      ? {
          backgroundSize: "cover",
          backgroundPosition: "100% 60%",
          height: "60vh",
          maxHeight: "600px",
          minHeight: "300px",
          // backgroundPositionY: "-30vh",
          // backgroundRepeat: "no-repeat",
          backgroundImage: 'url("/static/image/travel5.png")',
        }
      : {
          backgroundSize: "cover",
          backgroundPosition: "50% 0%",
          height: "21vh",
          maxHeight: "300px",
          // backgroundPositionY: "-68px",
          // backgroundRepeat: "no-repeat",
          backgroundImage: 'url("/static/image/default2.jpg")',
        };

  if (type === "blog" && is_phone) {
    style = {
      backgroundSize: "cover",
      backgroundPosition: "50% 0%",
      height: "10vh",
      maxHeight: "300px",
      // backgroundPositionY: "-68px",
      // backgroundRepeat: "no-repeat",
      backgroundImage: 'url("/static/image/default2.jpg")',
    };
  }

  if (type === "index" && is_phone) {
    style = {
      backgroundSize: "cover",
      backgroundPosition: "50% 0%",
      height: "25vh",
      maxHeight: "600px",
      minHeight: "100px",
      backgroundPositionY: "-40px",
      backgroundRepeat: "no-repeat",
      backgroundImage: 'url("/static/image/travel5.png")',
    };
  }

  let phoneSearchStyle = {};
  if (is_phone) {
    phoneSearchStyle = {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    };
  }

  const username = localStorage.getItem("username");
  return (
    <Box
      sx={{
        flexGrow: 1,
        bgcolor: is_phone ? "#000000" : "#1a1a1a",
        position: "relative",
        display: "flex",
        justifyContent: "center",
        ...style,
      }}
    >
      <Container
        maxWidth={false}
        sx={{
          width: "70vw",
          alignItems: "center",
          display: "flex",
          color: "white",
          height: "10vh",
          position: "relative",
        }}
      >
        <Typography
          variant="h6"
          component="div"
          sx={{
            flexGrow: 1,
            cursor: "pointer",
            fontSize: is_phone ? "16px" : "1.25rem",
          }}
          onClick={() => {
            if (window.location.pathname !== "/") {
              navigate("/");
              // window.location.reload();
            } else {
              // 2024-5-31 14:58:12 在首页点击首页时, 重载首页
              navigate("/");
              window.location.reload();
            }
          }}
        >
          Spectator Blog
        </Typography>
        {is_phone ? (
          ""
        ) : (
          <Button
            color="inherit"
            sx={{ marginRight: "10px" }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              navigate("/user/about");
            }}
          >
            ABOUT
          </Button>
        )}
        {username ? (
          <Box
            sx={{
              position: "relative",
            }}
            onMouseEnter={() => setUserLabelShow("block")}
            onMouseLeave={() => setUserLabelShow("none")}
          >
            <Button
              color="inherit"
              sx={{
                alignItems: "center",
                display: "flex",
                fontSize: is_phone ? "12px" : "0.875rem",
              }}
            >
              用户: {username}
            </Button>
            <Box
              sx={{
                display: userLabelShow,
                position: "absolute",
                margin: 0,
                width: "100%",
                bgcolor: "#6e6c6c",
                borderRadius: "5px",
              }}
            >
              {is_phone ? (
                ""
              ) : (
                <Button
                  color="inherit"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    navigate("/user/chatGPT");
                  }}
                  sx={{
                    margin: 0,
                    width: "100%",
                  }}
                >
                  ChatGpt
                </Button>
              )}
              <Button
                color="inherit"
                onClick={(e) => {
                  e.preventDefault();
                  // e.stopPropagation();
                  navigate("/blog/create");
                }}
                sx={{
                  margin: 0,
                  width: "100%",
                }}
              >
                发表文章
              </Button>
              <Button
                color="inherit"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  localStorage.clear();
                  setLogoutRender(!logoutRender); // 退出刷新状态
                }}
                sx={{
                  margin: 0,
                  width: "100%",
                }}
              >
                LOGOUT
              </Button>
            </Box>
          </Box>
        ) : (
          <Button color="inherit" onClick={() => navigate("/user/login")}>
            LOGIN
          </Button>
        )}
      </Container>
      {type === "index" ? (
        <Container
          maxWidth={false}
          sx={{
            width: "70vw",
            minWidth: "300px",
            alignItems: "flex-end",
            display: "flex",
            color: "white",
            // height: "50vh",
            position: "absolute",
            bottom: "0",

            justifyContent: is_phone ? "center" : "flex-start",
          }}
        >
          <Box
            sx={{
              width: "15vw",
              minWidth: "300px",

              ...phoneSearchStyle,
            }}
          >
            <Typography
              variant="h6"
              component="div"
              sx={{
                flexGrow: 1,
                height: "30px",
                fontSize: "12px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                WordBreak: "keep - all",
              }}
            >
              where'd you wanna go ? &nbsp; how much you wanna risk ?
            </Typography>
            <Box
              sx={{
                mb: "10px",
                display: "flex",
                alignItems: "center",
                width: is_phone ? "85%" : "100%",
              }}
            >
              <SearchInput
                inputSx={{
                  backgroundColor: "#babec2",
                  borderRadius: "6px",
                  width: "73%",
                  height: "30px",
                  fontSize: "12px",

                  ".MuiInputBase-input": {
                    padding: "0 5px 0 10px ",
                  },
                }}
                placeholder="输入搜索内容"
                defaultValue={defaultSearch}
                normalize={normalizeSearchInput}
                onSearch={(keyword) => {
                  store.dispatch({
                    type: "searchArticle",
                    payload: keyword,
                  });
                }}
                buttonColor="third"
                buttonSx={{ color: "third", ml: "10px" }}
              />
            </Box>
          </Box>
        </Container>
      ) : (
        ""
      )}
    </Box>
  );
}
